var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialFacebookbtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M.81 11h3.22v9.55h4.03V11h4.02V7.07H8.05v-2c0-.31.09-.6.25-.84.17-.24.35-.36.56-.36h3.22V0H8.86C7.54 0 6.4.5 5.46 1.51a5.1 5.1 0 00-1.43 3.63v1.93H.81V11z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-social--facebookbtn-0244a0b4d904af7479a05de37112bdde.svg";
export { SvgIconSocialFacebookbtn as Component };